import React, { useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Divider } from '@mui/material'
import TextBox from '../../../common/TextBox'
import MButton from '../../../common/MButton'
import { useDispatch, useSelector } from 'react-redux'
import { logOut, showErrorAlert, showSuccessAlert } from '../../../redux/Actions'
import { getAgentUsersChangePassword } from '../../../redux/Booking/BookingActions'

const ChangeUserPassword = (props) => {
    const { open = false, titleText = '', onClose = () => { } } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const [filterValue, setFilterValue] = useState({
        oldPwd: '',
        newPwd: '',
        confrimPwd: '',
    })
    const handleField = (event) => {
        setFilterValue((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }))
    }
    const handleUpdate = () => {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,12}$/;
        if (filterValue.oldPwd.trim() === '') {
            dispatch(showErrorAlert('Enter Old Password'))
        } else if (filterValue.newPwd.trim() === '') {
            dispatch(showErrorAlert('Enter New Password'))
        } else if (filterValue.confrimPwd.trim() === '') {
            dispatch(showErrorAlert('Enter Confrim Password'))
        } else if (filterValue.newPwd.trim() !== filterValue.confrimPwd.trim()) {
            dispatch(showErrorAlert('The password and confirmation password must be the same.'))
        } else if (filterValue.newPwd.trim() === filterValue.oldPwd.trim()) {
            dispatch(showErrorAlert('New password must be different from old password'))
        } else if (!passwordRegex.test(filterValue.newPwd.trim())) {
            dispatch(showErrorAlert('Password must be 6-12 characters, include at least 1 letter and 1 number'))
        } else {
            const body = {
                intUserID: userDetails.AgentUserID,
                strLoginID: userDetails.LoginID,
                strOldPassword: filterValue.oldPwd?.trim() || '',
                strNewPassword: filterValue.newPwd?.trim() || ''
            }
            dispatch(getAgentUsersChangePassword(body)).then((res) => {
                if (res.data.status) {
                    dispatch(showSuccessAlert('Password changed successfully!'))
                    dispatch(logOut())
                } else {
                    dispatch(res.data.Message)
                }
            })
        }
    }
    return (
        <>
            <CustomizedDialogs
                open={open}
                titleText={titleText}
                width={'450px'}
                height={'auto'}
                onClose={onClose}
                padding={'0px'}
            >
                <Box
                    className='scrollBlueV6'
                    maxHeight={'78vh'}
                    sx={{
                        overflowY: 'auto',

                    }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px' }}>
                        <Box>
                            <TextBox label='Login ID' value={userDetails.LoginID} disabled={true} />
                        </Box>
                        <Box>
                            <TextBox label='Old Password' isPassWord={true} value={filterValue.oldPwd} name='oldPwd' onChange={handleField} />
                        </Box>
                        <Box>
                            <TextBox label='New Password' isPassWord={true} maxLength={12} value={filterValue.newPwd} name='newPwd' onChange={handleField} />
                        </Box>
                        <Box>
                            <TextBox label='Confirm  Password' isPassWord={true} maxLength={12} value={filterValue.confrimPwd} name='confrimPwd' onChange={handleField} />
                        </Box>
                    </Box>
                    <Divider sx={{ borderColor: '#cccccc' }} />
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px', padding: '12px 16px' }}>
                        <MButton variant='outlined' btnName="Cancel" onClick={onClose} />
                        <MButton btnName="Update"
                            onClick={handleUpdate}
                        />
                    </Box>

                </Box>
            </CustomizedDialogs>
        </>
    )
}

export default ChangeUserPassword